// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-wrapper {
  border-radius: 5px;
  border: 1px solid #EFEFEF;
  display: flex;
  flex-direction: column;
  padding: 1vw;
}
.chart-wrapper__title {
  color: black;
  font-weight: 500;
  font-size: 0.75rem;
  margin-bottom: 1vw;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/chart-wrapper/chart-wrapper.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;AAAI;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAER","sourcesContent":[".chart-wrapper{\n    border-radius: 5px;\n    border:1px solid #EFEFEF;\n    display: flex;\n    flex-direction: column;\n    padding: 1vw;\n    &__title{\n        color: black;\n        font-weight: 500;\n        font-size: 0.75rem;\n        margin-bottom: 1vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
